var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entry.id && _vm.entry.play_after_entry)?_c('div',{staticClass:"mt-1",attrs:{"title":_vm.tooltip}},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"msr","small":""}},[_vm._v("\n      link\n    ")]),_vm._v(" "),_c('small',{staticClass:"msr--text"},[_vm._v(_vm._s(_vm.entry.play_after_entry.spot.title))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PlayAfterEntryStatus.vue?vue&type=template&id=1f969b5c&
// module id = 2281
// module chunks = 5